import React from 'react';
import { Stack, Text } from '@mantine/core';

import { centsToDollars, moneyFormat } from '@/helpers';
import { PopupEventVendorDetailsCompleted } from '../types';

type PopupCompletedTotalProps = {
  event: PopupEventVendorDetailsCompleted;
};

const PopupCompletedTotal: React.FC<PopupCompletedTotalProps> = ({
  event: { sales, mealPrep },
}) => {
  const cash = moneyFormat(centsToDollars(sales?.totalCashPaymentsCents));
  const avg = moneyFormat(centsToDollars(sales?.avgCustomerPaidCents));

  return (
    <>
      <Stack gap="xs" p="sm" bdrs="md" bd="1px solid var(--mantine-color-gray-4)">
        <Text>
          Cash Payments: <strong>{cash}</strong>
        </Text>
        <Text>
          Average Check Amount: <strong>{avg}</strong>
        </Text>
        <Text c="dimmed" fz="sm" fs="italic">
          Amounts shown include taxes
        </Text>
      </Stack>
      <Stack gap="xs" p="sm" bdrs="md" bd="1px solid var(--mantine-color-gray-4)">
        <Text>
          Meal Prep: <strong>{mealPrep?.prepFor ?? 0}</strong>
        </Text>
        <Text>
          Meals Sold: <strong>{sales?.mealsSold ?? 0}</strong>
        </Text>
      </Stack>
    </>
  );
};

export default PopupCompletedTotal;
